// extracted by mini-css-extract-plugin
module.exports = {"joinWaitListWrapper":"styles_joinWaitListWrapper__gMapw","joinWaitListTitle":"styles_joinWaitListTitle__uR9Az","spotOpenText":"styles_spotOpenText__2tfwl"};